// Single point of access for build-time configuration.
// Values are inlined at build time (webpack DefinePlugin / Vite define).
export default {
  CMS_CONTRACT_CLICK_OPEN_ORDERSLIP: process.env.CMS_CONTRACT_CLICK_OPEN_ORDERSLIP,
  ANONYMOUS_SIGNALR: process.env.ANONYMOUS_SIGNALR,
  ASSETS_CDN_URL: process.env.ASSETS_CDN_URL,
  ATTACH_TO_HOME_POPUP_ENABLED: process.env.ATTACH_TO_HOME_POPUP_ENABLED,
  BANNER_ENABLED: process.env.BANNER_ENABLED,
  CHART_CSV_DOWNLOAD_URL: process.env.CHART_CSV_DOWNLOAD_URL,
  CHARTS_LIVE_UPDATES_ENABLED: process.env.CHARTS_LIVE_UPDATES_ENABLED,
  DARK_MODE_ENABLED: process.env.DARK_MODE_ENABLED,
  DEPOSIT_PROMO_INPUT_BOX_ENABLED: process.env.DEPOSIT_PROMO_INPUT_BOX_ENABLED,
  DISABLE_TWO_FACTOR_PROMPT: process.env.DISABLE_TWO_FACTOR_PROMPT,
  DISQUS_PUBLIC_KEY: process.env.DISQUS_PUBLIC_KEY,
  DISQUS_SHORTNAME: process.env.DISQUS_SHORTNAME,
  DISQUS_SSO_BUTTON: process.env.DISQUS_SSO_BUTTON,
  DISQUS_SSO_HEIGHT: process.env.DISQUS_SSO_HEIGHT,
  DISQUS_SSO_ICON: process.env.DISQUS_SSO_ICON,
  DISQUS_SSO_LOGOUT: process.env.DISQUS_SSO_LOGOUT,
  DISQUS_SSO_NAME: process.env.DISQUS_SSO_NAME,
  DISQUS_SSO_URL: process.env.DISQUS_SSO_URL,
  DISQUS_SSO_WIDTH: process.env.DISQUS_SSO_WIDTH,
  EMAIL_MARKETS: process.env.EMAIL_MARKETS,
  EMAIL_PRESS: process.env.EMAIL_PRESS,
  EMAIL_SUPPORT: process.env.EMAIL_SUPPORT,
  FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
  FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL: process.env.FIREBASE_DATABASE_URL,
  FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
  GOOGLE_GTM: process.env.GOOGLE_GTM,
  LEADERBOARDS_ENABLED: process.env.LEADERBOARDS_ENABLED,
  LS_TTL_BROWSE_HEADERS: process.env.LS_TTL_BROWSE_HEADERS,
  LS_TTL_USER_DISQUS_LOGIN: process.env.LS_TTL_USER_DISQUS_LOGIN,
  LS_TTL_USER_MARKET_DISPLAY: process.env.LS_TTL_USER_MARKET_DISPLAY,
  NODE_ENV: process.env.NODE_ENV,
  PI_FACEBOOK_LINK: process.env.PI_FACEBOOK_LINK,
  PI_INSTAGRAM_LINK: process.env.PI_INSTAGRAM_LINK,
  PINNING_ENABLED: process.env.PINNING_ENABLED,
  INSIGHTS_ENABLED: process.env.INSIGHTS_ENABLED,
  INSIGHTS_COUNTY_MAPS_URL: process.env.INSIGHTS_COUNTY_MAPS_URL,
  ELECTION_PAGES_PUBLIC_ENABLED: process.env.ELECTION_PAGES_PUBLIC_ENABLED,
  PI_TWITTER_LINK: process.env.PI_TWITTER_LINK,
  PI_YOUTUBE_LINK: process.env.PI_YOUTUBE_LINK,
  PRIVACY_STATEMENT_ENABLED: process.env.PRIVACY_STATEMENT_ENABLED,
  PUSH_NOTIFICATIONS_JOURNEY_ENABLED: process.env.PUSH_NOTIFICATIONS_JOURNEY_ENABLED,
  REAL_API_URL: process.env.REAL_API_URL,
  REFRESH_TOKEN_INTERVAL: process.env.REFRESH_TOKEN_INTERVAL,
  RESTRICTED_ACCESS_ENABLED: process.env.RESTRICTED_ACCESS_ENABLED,
  ROOT_PATH: process.env.ROOT_PATH,
  SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS:
    process.env.SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS,
  SECONDS_TO_ENABLE_WEBSOCKETS: process.env.SECONDS_TO_ENABLE_WEBSOCKETS,
  SENTRY_DSN: process.env.SENTRY_DSN,
  SHOW_MAP_ON_HOMEPAGE: process.env.SHOW_MAP_ON_HOMEPAGE,
  SHOW_PRICE_NOTIFICATION_SETTINGS: process.env.SHOW_PRICE_NOTIFICATION_SETTINGS,
  SHUTDOWN_ENABLED: process.env.SHUTDOWN_ENABLED,
  SIGNALR_URL: process.env.SIGNALR_URL,
  SOCIAL_AUTH_URL: process.env.SOCIAL_AUTH_URL,
  TOURNAMENT_LINK: process.env.TOURNAMENT_LINK,
  TOURNAMENT_LINK_ENABLED: process.env.TOURNAMENT_LINK_ENABLED,
  TRADE_CSV_DOWNLOAD_URL: process.env.TRADE_CSV_DOWNLOAD_URL,
  TRANSACTION_CSV_DOWNLOAD_URL: process.env.TRANSACTION_CSV_DOWNLOAD_URL,
  TWITTER_HANDLE: process.env.TWITTER_HANDLE,
  USE_API_WRAPPER: process.env.USE_API_WRAPPER,
  COLLEGE_AFFILIATION_ENABLED: process.env.COLLEGE_AFFILIATION_ENABLED,
};
